var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcNftCollection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 24C20.4183 24 24 20.4183 24 16C24 11.5817 20.4183 8 16 8C11.5817 8 8 11.5817 8 16C8 20.4183 11.5817 24 16 24ZM16 26C21.5228 26 26 21.5228 26 16C26 10.4772 21.5228 6 16 6C10.4772 6 6 10.4772 6 16C6 21.5228 10.4772 26 16 26Z",
    fill: "CURRENTCOLOR"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11C15 10.4477 15.4477 10 16 10C16.5523 10 17 10.4477 17 11C18.6569 11 20 12.3431 20 14C20 14.5523 19.5523 15 19 15C18.4477 15 18 14.5523 18 14C18 13.4477 17.5523 13 17 13H14.7434C14.3328 13 14 13.3328 14 13.7434C14 14.0634 14.2048 14.3475 14.5083 14.4487L18.1241 15.6539C19.2444 16.0274 20 17.0757 20 18.2566C20 19.7717 18.7717 21 17.2566 21H17C17 21.5523 16.5523 22 16 22C15.4477 22 15 21.5523 15 21C13.3431 21 12 19.6569 12 18C12 17.4477 12.4477 17 13 17C13.5523 17 14 17.4477 14 18C14 18.5523 14.4477 19 15 19H17.2566C17.6672 19 18 18.6672 18 18.2566C18 17.9366 17.7952 17.6525 17.4917 17.5513L13.8759 16.3461C12.7556 15.9726 12 14.9243 12 13.7434C12 12.2283 13.2283 11 14.7434 11H15Z",
    fill: "CURRENTCOLOR"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNftCollection);
export default __webpack_public_path__ + "static/media/ic-nft-collection.12d81f83.svg";
export { ForwardRef as ReactComponent };